const LOCAL_HOST = 'localhost:9905';

export function getIsOta(): boolean {
    const boolIsOta: string = '{<BOOL_IS_OTA>}';
    return window.location.host === LOCAL_HOST || boolIsOta === 'true';
}
